import 'projects/sharedComponents/src/breedSummary/legacyBreedSummaryBars.scss';

import {
  LegacyBreedSummaryBarsFragment,
  ProductType,
} from 'projects/sharedComponents/src/generated/graphql-client-types';

import { FC } from 'react';
import { LegacyBreedSummaryBar } from 'projects/sharedComponents/src/breedSummary/legacyBreedSummaryBar';
import { Typography } from '@mui/material';

type LegacyBreedSummaryBarsProps = {
  dog: LegacyBreedSummaryBarsFragment;
};

export const LegacyBreedSummaryBars: FC<LegacyBreedSummaryBarsProps> = ({ dog }) => {
  const isPurebredKit = dog.swabSummary.productType === ProductType.Purebred;
  return (
    <>
      {dog.genotype?.breedMix.map((breed) => {
        return (
          <div key={breed.colorIndex}>
            <Typography>
              {breed.displayBreedPercent} {breed.breedName}
            </Typography>
            <LegacyBreedSummaryBar
              colorIndex={breed.colorIndex}
              width={breed.barWidthPercentage}
              isPurebredKit={isPurebredKit}
            />
          </div>
        );
      })}
    </>
  );
};
